module.exports = __webpack_public_path__ + "img/figure.0b78344.webp";